'use strict';

var $isNaN = require('./isNaN');

/** @type {import('./sign')} */
module.exports = function sign(number) {
	if ($isNaN(number) || number === 0) {
		return number;
	}
	return number < 0 ? -1 : +1;
};



//////////////////
// WEBPACK FOOTER
// ./~/math-intrinsics/sign.js
// module id = 1662
// module chunks = 1